import { createAsyncThunk } from "@reduxjs/toolkit";
import { getTask } from "api/tasks/tasks";

export const downloadTask = createAsyncThunk("task/download-by-id", async (taskId: string) => {
  const task = await getTask(taskId);

  return { [task.id]: task };
});
